import type { TourTargetCatalogEntry } from './types'

/** Targets for the `customize-invoice-template` virtual tour (branding only). */
export const CUSTOMIZE_INVOICE_TEMPLATE_TOUR_TARGETS = {
  navCustomization: {
    key: 'navCustomization',
    route: '/app/template_customization',
    selector: '[data-tour="template-customization-list"]',
    description:
      'Template customization page list (App Bridge nav is outside the app frame; tour starts here)',
    featureArea: 'Templates',
    waitTimeoutMs: 12000,
  },
  templateCustomizeInvoice: {
    key: 'templateCustomizeInvoice',
    route: '/app/template_customization',
    selector: '[data-tour="template-customize-invoice"]',
    description: 'Customize button on the Fordeer for Invoice template row',
    featureArea: 'Templates',
    waitTimeoutMs: 15000,
    interactionMode: 'interactive',
    advanceOnPath: '/app/themes/edit/',
    advanceOnPathMatch: 'prefix',
  },
  themeEditorSectionNav: {
    key: 'themeEditorSectionNav',
    route: '/app/themes/edit/:themeId',
    selector: '[data-tour="theme-editor-branding-nav"]',
    description: 'Branding item in the theme editor section menu',
    featureArea: 'Templates',
    routeMatch: 'prefix',
    waitTimeoutMs: 60_000,
  },
  themeEditorTypography: {
    key: 'themeEditorTypography',
    route: '/app/themes/edit/:themeId',
    selector: '[data-tour="theme-editor-typography"]',
    description: 'Typography section in the branding panel',
    featureArea: 'Templates',
    routeMatch: 'prefix',
    waitTimeoutMs: 60_000,
  },
  themeEditorRemoveBranding: {
    key: 'themeEditorRemoveBranding',
    route: '/app/themes/edit/:themeId',
    selector: '[data-tour="theme-editor-remove-branding"]',
    description: 'Remove Fordeer branding toggle in the theme editor sidebar',
    featureArea: 'Templates',
    routeMatch: 'prefix',
    waitTimeoutMs: 60_000,
  },
} as const satisfies Record<string, TourTargetCatalogEntry>

export type CustomizeInvoiceTemplateTourTargetKey =
  keyof typeof CUSTOMIZE_INVOICE_TEMPLATE_TOUR_TARGETS

export const CUSTOMIZE_INVOICE_TEMPLATE_TOUR_TARGET_KEY = {
  navCustomization: 'navCustomization',
  templateCustomizeInvoice: 'templateCustomizeInvoice',
  themeEditorSectionNav: 'themeEditorSectionNav',
  themeEditorTypography: 'themeEditorTypography',
  themeEditorRemoveBranding: 'themeEditorRemoveBranding',
} as const satisfies { readonly [K in CustomizeInvoiceTemplateTourTargetKey]: K }
